import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import { Fab } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React from 'react';

interface Props {
  isChatVisible: boolean;
  isDisabled: boolean;
  onOpenChatClick: () => void;
  onToggleMinimize: () => void;
}

const MoxoFab = ({
  isChatVisible,
  isDisabled,
  onOpenChatClick,
  onToggleMinimize,
}: Props) => {
  const { palette } = useTheme();

  return !isChatVisible ? (
    <Fab
      aria-label="open-chat"
      color="primary"
      disabled={isDisabled}
      onClick={onOpenChatClick}
      size="medium"
      sx={{
        backgroundColor: palette.primary.light,
        bottom: '-60px',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        right: '-17px',
      }}
    >
      <ChatBubbleIcon />
    </Fab>
  ) : (
    <Fab
      aria-label="toggle-chat"
      color="primary"
      onClick={onToggleMinimize}
      size="medium"
      sx={{
        backgroundColor: palette.primary.light,
        bottom: '-60px',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        right: '-17px',
      }}
    >
      <ExpandMoreIcon />
    </Fab>
  );
};

export default MoxoFab;
